import type { WidgetDataSource, WidgetParameter } from "../../../types/widget";

export const DEFAULT_PARAMETERS: WidgetParameter[] = [
  { name: "from", type: "datetime", bind: "dashboard.dateFrom", required: true },
  { name: "to", type: "datetime", bind: "dashboard.dateTo", required: true },
];

export const DEFAULT_DSL = `{
  "size": 0,
  "query": {
    "bool": {
      "filter": [
        {
          "range": {
            "{{timeField}}": {
              "gte": "{{from}}",
              "lte": "{{to}}",
              "format": "strict_date_optional_time"
            }
          }
        }
      ]
    }
  }
}`;

export function emptyQuery() {
  return {
    name: "",
    description: "",
    dataSource: {
      sourceType: "OPENSEARCH",
      queryLanguage: "OPENSEARCH_DSL",
      sources: [{ index: "", timeField: "" }],
      indices: [],
      timeField: "",
      dslTemplate: JSON.parse(DEFAULT_DSL),
      parameters: DEFAULT_PARAMETERS,
    } as WidgetDataSource,
  };
}

export function parseJsonField(raw: string, fieldLabel: string): Record<string, unknown> {
  try {
    return JSON.parse(raw) as Record<string, unknown>;
  } catch {
    throw new Error(`${fieldLabel}: invalid JSON`);
  }
}

export function isValidJson(raw: string): boolean {
  try {
    JSON.parse(raw);
    return true;
  } catch {
    return false;
  }
}
